export default __webpack_public_path__ + "static/punjabsweets-6640e56af7a721c9762b5c26a3e65ee4.svg";